const STORAGE_PREFIX = 'tpp_claim_step1_overlay_ack_';

export const step1OverlayStorageKey = (claimId: number): string =>
  `${STORAGE_PREFIX}${claimId}`;

export const hasAcknowledgedStep1Overlay = (claimId: number): boolean =>
  sessionStorage.getItem(step1OverlayStorageKey(claimId)) === '1';

export const acknowledgeStep1Overlay = (claimId: number): void => {
  sessionStorage.setItem(step1OverlayStorageKey(claimId), '1');
};
